import { render, staticRenderFns } from "./user-balance-use.vue?vue&type=template&id=1662fee6&scoped=true&"
import script from "./user-balance-use.vue?vue&type=script&lang=js&"
export * from "./user-balance-use.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1662fee6",
  null
  
)

export default component.exports